module.exports = __webpack_public_path__ + "static/media/392.386a660e.svg";